export default __webpack_public_path__ + "static/media/poll.c138cddd.jpg";